import { ReactComponent as LineIcon } from './line.svg';

export const WithDrawalIcons = {
  LineIcon,
};
